module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top heightAuto",
    attrs: {
      "dialog": "modal-lg",
      "footer": false
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.isNewAccount) ? _c('h2', [_vm._v("Create Account")]) : _c('h2', [_vm._v("Edit Account")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form py-3 flexGrow1"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "w-100 d-flex justify-content-between"
  }, [_c('div', [_vm._v("User Info")]), _vm._v(" "), (_vm.accessPermissionFilter(['admin'])) ? _c('div', [_vm._v("\n                        Active\n                        "), _c('toggle-button', {
    staticClass: "ml-3",
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    model: {
      value: (_vm.userAccount.isActive),
      callback: function($$v) {
        _vm.$set(_vm.userAccount, "isActive", $$v)
      },
      expression: "userAccount.isActive"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('avatar-uploader', {
    attrs: {
      "value": _vm.userAccount.imagePhotoBase64 || _vm.userAccount.imagePhoto,
      "originalImage": _vm.originalUserAccount && (_vm.originalUserAccount.imagePhotoBase64 || _vm.originalUserAccount.imagePhoto),
      "placeholder": 'agent',
      "showPreview": true,
      "showButton": true,
      "showRequirements": true,
      "requirementsBelowImage": false,
      "buttonType": 'picture',
      "isSizeOk": _vm.avatarRequirements.isSizeOk,
      "isFormatOk": _vm.avatarRequirements.isFormatOk,
      "image": _vm.userAccount.imagePhoto,
      "imageBase64": _vm.userAccount.imagePhotoBase64,
      "imageHash": _vm.userAccount.imagePhotoHash,
      "originalImageSync": _vm.originalUserAccount.imagePhoto,
      "originalImageBase64Sync": _vm.originalUserAccount.imagePhotoBase64,
      "originalHashSync": _vm.originalUserAccount.imagePhotoHash
    },
    on: {
      "update:isSizeOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:is-size-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:isFormatOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:is-format-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:image": function($event) {
        return _vm.$set(_vm.userAccount, "imagePhoto", $event)
      },
      "update:imageBase64": function($event) {
        return _vm.$set(_vm.userAccount, "imagePhotoBase64", $event)
      },
      "update:image-base64": function($event) {
        return _vm.$set(_vm.userAccount, "imagePhotoBase64", $event)
      },
      "update:imageHash": function($event) {
        return _vm.$set(_vm.userAccount, "imagePhotoHash", $event)
      },
      "update:image-hash": function($event) {
        return _vm.$set(_vm.userAccount, "imagePhotoHash", $event)
      },
      "update:originalImageSync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhoto", $event)
      },
      "update:original-image-sync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhoto", $event)
      },
      "update:originalImageBase64Sync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhotoBase64", $event)
      },
      "update:original-image-base64-sync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhotoBase64", $event)
      },
      "update:originalHashSync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhotoHash", $event)
      },
      "update:original-hash-sync": function($event) {
        return _vm.$set(_vm.originalUserAccount, "imagePhotoHash", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Name\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userAccount.name),
      expression: "userAccount.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userAccount.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userAccount, "name", $event.target.value)
      }, _vm.$v.userAccount.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.userAccount.name.$error) ? _c('div', {
    staticClass: "fs-small color-6"
  }, [(!_vm.$v.userAccount.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Email\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userAccount.email),
      expression: "userAccount.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isNewAccount
    },
    domProps: {
      "value": (_vm.userAccount.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userAccount, "email", $event.target.value.trim())
      }, _vm.$v.userAccount.email.$touch],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.userAccount.email.$error) ? _c('div', {
    staticClass: "fs-small color-6"
  }, [(!_vm.$v.userAccount.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.email.isUnique) ? _c('span', [_vm._v("This email is already in use.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.selectedAccesType && _vm.accessPermissionFilter(['admin'])) ? _c('div', {
    staticClass: "col-sm-6 mt-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Access type\n                            ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getUserAccessTypes,
      "disabled": _vm.isEditingOwnAdminAccessType
    },
    on: {
      "input": _vm.accessTypeChanged
    },
    model: {
      value: (_vm.selectedAccesType),
      callback: function($$v) {
        _vm.selectedAccesType = $$v
      },
      expression: "selectedAccesType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getSalesChannels && _vm.accessPermissionFilter(['admin'])) ? _c('div', {
    staticClass: "col-sm-6 mt-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Sales Channel\n                            ")]), _vm._v(" "), (_vm.userAccount.salesChannel) ? _c('div', [_c('v-select', {
    attrs: {
      "options": _vm.possibleSalesChannels,
      "label": "name"
    },
    model: {
      value: (_vm.userAccount.salesChannel),
      callback: function($$v) {
        _vm.$set(_vm.userAccount, "salesChannel", $$v)
      },
      expression: "userAccount.salesChannel"
    }
  })], 1) : _c('div', [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.setSalesChannel
    }
  }, [_vm._v("Set Sales Channel")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mt-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Default Homepage (after login)\n                            ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.homePagesOptions,
      "label": "name"
    },
    on: {
      "input": function($event) {
        return _vm.homePageChanged($event)
      }
    },
    model: {
      value: (_vm.homePage),
      callback: function($$v) {
        _vm.homePage = $$v
      },
      expression: "homePage"
    }
  })], 1)])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Name\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userAccount.name),
      expression: "userAccount.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userAccount.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userAccount, "name", $event.target.value)
      }, _vm.$v.userAccount.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.userAccount.name.$error) ? _c('div', {
    staticClass: "fs-small color-6"
  }, [(!_vm.$v.userAccount.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Email\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.userAccount.email),
      expression: "userAccount.email",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isNewAccount
    },
    domProps: {
      "value": (_vm.userAccount.email)
    },
    on: {
      "blur": [_vm.$v.userAccount.email.$touch, function($event) {
        return _vm.$forceUpdate()
      }],
      "change": function($event) {
        _vm.$set(_vm.userAccount, "email", $event.target.value.trim())
      }
    }
  })]), _vm._v(" "), (_vm.$v.userAccount.email.$error) ? _c('div', {
    staticClass: "fs-small color-6"
  }, [(!_vm.$v.userAccount.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userAccount.email.isUnique) ? _c('span', [_vm._v("This email is already in use.")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group d-flex"
  }, [(_vm.selectedAccesType) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Access type\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getUserAccessTypes
    },
    on: {
      "input": _vm.accessTypeChanged
    },
    model: {
      value: (_vm.selectedAccesType),
      callback: function($$v) {
        _vm.selectedAccesType = $$v
      },
      expression: "selectedAccesType"
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-4 p-3"
  }, [_c('div', [(_vm.accessPermissionFilter(['admin']) && _vm.userAccount && _vm.userAccount.id !== _vm.account.id) ? _c('button', {
    staticClass: "btn action wider",
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('i', {
    staticClass: "ico ico-delete"
  }), _vm._v(" Delete Account\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn green wider",
    class: {
      'opacity-50': _vm.isFormInvalid || _vm.validateSupplier
    },
    attrs: {
      "disabled": _vm.loading || _vm.isFormInvalid || _vm.validateSupplier
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? 'Saving...' : 'Save'))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a4aa0656", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4aa0656"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/supplierAccountModal.vue
// module id = 2374
// module chunks = 0